<template>
  <div class="login-page">
    <div class="background-blue">
      <div class="logo">
        <div class="brand">
          <span>Welcome</span><br />
          <span>to easypaper</span>
        </div>
        <div class="trace"></div>
      </div>
    </div>
    <div class="container-login">
      <div class="box-login">
        <div class="title">
          <span>Password recovery</span>
        </div>
        <div class="username"  v-if="!token">
          <input
            v-model="email"
            class="inputs margin-input-login user"
            type="text"
            placeholder="Username"
          >
        </div>
        <div class="username"  v-if="token">
          <input
            v-model="email"
            class="inputs margin-input-login user"
            type="text"
            placeholder="Confirm your e-mail"
          >
        </div>
        <div class="password" v-if="token">
          <input
            v-model="password"
            class="inputs padlock"
            type="password"
            placeholder="New Password"
          >
        </div>
        <div class="password" v-if="token">
          <input
            v-model="confirmPassword"
            class="inputs padlock"
            type="password"
            placeholder="Confirm Password"
          >
        </div>
        <div v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <div v-if="successMessage">
          {{ successMessage }}
        </div>
        <div>
          <button
            @click="valid()"
            class="btn-login"
          >Reset</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'passwordRecovery',
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      errorMessage: '',
      successMessage: '',
      token: '',
    };
  },
  mounted() {
    if (this.$route.params.token) {
      this.token = this.$route.params.token;
    }
  },
  methods: {
    valid() {
      if (this.token) {
        if (this.password.length < 8 || this.password !== this.confirmPassword) {
          this.errorMessage = 'The password needs at least 8 characters.';
          return this.errorMessage;
        }
        return this.newPassword();
      }
      this.errorMessage = '';
      if (!this.email) {
        this.errorMessage = 'Fill in the required fields.';
        return this.errorMessage;
      }
      return this.passwordRecovery();
    },
    async passwordRecovery() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.email,
        }),
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/reset-password-request`, requestOptions)
        .then(async (response) => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          this.successMessage = data.message;
          this.errorMessage = '';
          return this.successMessage;
        })
        .catch((error) => {
          this.errorMessage = error;
        });
    },
    async newPassword() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword,
          passwordToken: this.token,
        }),
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/change-password`, requestOptions)
        .then(async (response) => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.error) || (data && data.message) || response.status;
            return Promise.reject(error);
          }
          this.successMessage = data.message;
          this.errorMessage = '';
          return this.successMessage;
        })
        .catch((error) => {
          this.errorMessage = error;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// esses estilos estão aqui pois no _input ele não encontrava o caminho
.logo {
  background-image: url("./../assets/background/background-login.svg");
  background-size: cover;
}
.user {
  background-image: url("../../src/assets/icons/user.svg");
  background-position: 17px;
}
.padlock {
  background-image: url("../../src/assets/icons/password.svg");
  background-position: 17px;
}
</style>
